import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  templates: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    '& h2': {
      fontSize: 30,
      fontWeight: 400,
      color: '#616161',
      margin: 0,
    },

    '& p': {
      color: '#616161',
    },

    '& h2 span': {
      color: '#D6246E',
      fontWeight: 700,
    },
  },
  paragraph: {
    lineHeight: 1.15,
    fontFamily: 'Lato',
  },
}));
